export const shouldAutoEnableSelectedRoofPlacement = (
  previousSelectedRoofSegmentCount: number,
  selectedRoofSegmentCount: number,
  panelPlacementOnlySelectedRoof: boolean
) =>
  previousSelectedRoofSegmentCount === 0 &&
  selectedRoofSegmentCount > 0 &&
  !panelPlacementOnlySelectedRoof;
